<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("schedule.title") }}</h1>
    <b-tabs content-class="mt-3" style="width:87%">
      <!-- 検索欄 -->
      <b-tab :title="this.$i18n.t('schedule.tab_search')" active>
        <b-card class="mb-3">
          <form>
            <b-form-group
              id="moSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_mo')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="moSearch" :placeholder="this.$i18n.t('schedule.placeholder_mo')"></b-form-input>
            </b-form-group>
            <b-form-group
              id="dateSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="dateSearch" v-model="dateSearch" type="date" class="mb-3"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2">
                </div>
                <div class="flex-fill">
                <b-form-group>
                  <b-form-radio-group id="period" v-model="period">
                    <b-form-radio value="0">{{this.$i18n.t('schedule.label_day')}}</b-form-radio>
                    <b-form-radio value="1">{{this.$i18n.t('schedule.label_week')}}</b-form-radio>
                    <b-form-radio value="2">{{this.$i18n.t('schedule.label_month')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                </div>
              </div>
            </b-form-group>
            <b-form-group
              id="codeListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_code')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="codeListSearch" :options="codeSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineListSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineListSearch" :options="lineSearchOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              label-cols-sm="8"
              label-cols-lg="8"
              :label="this.$i18n.t('schedule.label_caution')"
              label-for="input-horizontal"
            >
              <!-- 検索ボタン -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("schedule.button_search") }}</b-button>
            </b-form-group>
          </form>
        </b-card>
        <b-card v-if="isSearch" class="mb-3">
          <div class="m-4">
          <gantt-elastic
            :options="options"
            :tasks="tasks"
            @tasks-changed="tasksUpdate"
            @options-changed="optionsUpdate"
            @dynamic-style-changed="styleUpdate"
          >
            <gantt-header slot="header"></gantt-header>
          </gantt-elastic>
          </div>
        </b-card>
      </b-tab>
      <!-- 新規登録 -->
      <b-tab :title="this.$i18n.t('schedule.tab_register')" @click="createdRegist">
        <b-card class="w-100">
          <form>
            <b-form-group
              id="codeListForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_code')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="codeListForm" :options="codeFormOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineListForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineListForm" :options="lineFormOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="moForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_mo')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
              <div class="flex-fill pr-3">
              <b-form-input v-model="moForm" :placeholder="this.$i18n.t('schedule.placeholder_mo')"></b-form-input>
              </div>
              <div> </div>
              <div class="w-25">
              <b-button variant="primary" @click="searchRemain">{{ $i18n.t("schedule.button_search") }}</b-button>
              </div>
              </div>
            </b-form-group>
            <b-form-group
              id="sCountForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_scount')"
              label-for="input-horizontal"
            >
              <b-form-input class="w-50" v-model="sCountForm" :placeholder="this.$i18n.t('schedule.placeholder_scount')" maxlength="6"></b-form-input>
            </b-form-group>
            <b-form-group
              id="dateForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="from" v-model="from" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="fromTime" v-model="fromTime" type="time"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2">-</div>
                <div class="flex-fill">
                  <b-form-input id="to" v-model="to" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="toTime" v-model="toTime" type="time"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("linemente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearchRemain">
        <b-card class="mb-3">
          <!-- 残計画一覧 -->
          <h2
            :class="showCollapse ? 'collapsed' : null"
            :aria-expanded="showCollapse ? 'true' : 'false'"
            aria-controls="collapse-12"
            @click="showCollapse = !showCollapse"
          >{{this.$i18n.t('schedule.label_remainingplan')}}</h2>
          <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
              <b-pagination
              v-model="procCurrentPage"
              :total-rows="procTotalRows"
              :per-page="procPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
            <b-table
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :current-page="procCurrentPage"
              :per-page="procPerPage"
              :small="small"
              :hover="hover"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :no-border-collapse="noCollapse"
              :items="remainingplans"
              :fields="remainFields"
              :head-variant="headVariant"
              :table-variant="tableVariant"
            >
            <template v-slot:cell(mo)="row">
              <u>
                <b-link
                  @click="inputMo(row.item.mo, row.item.nonSchedulecnt)"
                  :class="showCollapse ? 'collapsed' : null"
                  :aria-expanded="showCollapse ? 'true' : 'false'"
                  aria-controls="collapse-12"
                >{{ row.item.mo }}</b-link>
              </u>
            </template>
            </b-table>
          </b-collapse>
        </b-card>
        </b-card>
      </b-tab>
    </b-tabs>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('schedule.info_register')" :titleMsg="this.$i18n.t('schedule.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
import GanttElastic from 'gantt-elastic'
import GanttHeader from 'gantt-elastic-header'

export default {
  components: {
    confirmModal,
    GanttElastic,
    GanttHeader
  },
  data () {
    return {
      dynamicStyle: {},
      // ガントチャート
      options: {
        taskMapping: {
          progress: 'percent'
        },
        maxRows: 500,
        maxHeight: 500,
        title: {
          label: 'Your project title as html (link or whatever...)',
          html: false
        },
        row: {
          height: 24
        },
        calendar: {
          hour: {
            display: true
          }
        },
        chart: {
          progress: {
            bar: false
          },
          expander: {
            display: true
          }
        },
        taskList: {
          expander: {
            straight: false
          },
          columns: [
            {
              id: 1,
              label: this.$i18n.t('schedule.label_line'),
              value: 'line',
              width: 100,
              style: {
                'task-list-header-label': {
                  color: '#696969'
                }
              }
            },
            {
              id: 2,
              label: this.$i18n.t('schedule.label_mo'),
              value: 'mo',
              width: 200,
              expander: true,
              html: true,
              style: {
                'task-list-header-label': {
                  color: '#696969'
                }
              },
              events: {
                click ({ data }) {
                  var path = '/#/scheduleEdit?mo=' + data.hidmo + '&moSeq=' + data.moSeq + '&scount=' + data.schedulecnt + '&code=' + data.label + '&hidcode=' + data.hidCode + '&hidrev=' + data.hidRev + '&line=' + data.lineId + '&sFlag=' + data.scheduleFlag + '&start=' + data.hidStart + '&end=' + data.hidEnd
                  window.location.href = 'http://' + window.location.host + path
                }
              }
            },
            {
              id: 3,
              label: this.$i18n.t('schedule.label_start'),
              value: 'start',
              width: 150,
              style: {
                'task-list-header-label': {
                  color: '#696969'
                }
              }
            },
            {
              id: 4,
              label: this.$i18n.t('schedule.label_end'),
              value: 'end',
              width: 150,
              style: {
                'task-list-header-label': {
                  color: '#696969'
                }
              }
            },
            {
              id: 5,
              label: this.$i18n.t('schedule.label_scount'),
              value: 'schedulecnt',
              width: 40,
              style: {
                'task-list-header-label': {
                  'text-align': 'center',
                  width: '100%',
                  color: '#696969'
                },
                'task-list-item-value-container': {
                  'text-align': 'center',
                  width: '100%'
                }
              }
            },
            {
              id: 6,
              label: this.$i18n.t('schedule.label_percent'),
              value: 'progress',
              width: 40,
              style: {
                'task-list-header-label': {
                  'text-align': 'center',
                  width: '100%',
                  color: '#696969'
                },
                'task-list-item-value-container': {
                  'text-align': 'center',
                  width: '100%'
                }
              }
            }
          ]
        },
        locale: {
          name: 'en',
          Now: 'Now',
          'X-Scale': 'Zoom-X',
          'Y-Scale': 'Zoom-Y',
          'Task list width': 'Task list',
          'Before/After': 'Expand',
          'Display task list': 'Task list'
        }
      },
      tasks: [],
      // 検索条件入力値
      moSearch: '',
      period: 0,
      dateSearch: '',
      codeListSearch: '',
      lineListSearch: '',
      codeSearchOptions: [{ value: '', text: this.$i18n.t('schedule.label_all_code') }],
      lineSearchOptions: [{ value: '', text: this.$i18n.t('schedule.label_all_line') }],
      // 新規登録入力値
      codeListForm: '',
      lineListForm: '',
      codeFormOptions: [{ value: '', text: this.$i18n.t('schedule.label_select') }],
      lineFormOptions: [{ value: '', text: this.$i18n.t('schedule.label_select') }],
      moForm: '',
      sCountForm: '',
      from: '',
      to: '',
      fromTime: '',
      defFromTime: '',
      toTime: '',
      defToTime: '',
      // 残計画
      remainingplans: [],
      remainFields: [
        { key: 'mo', label: this.$i18n.t('schedule.label_mo'), sortable: true },
        { key: 'nonSchedulecnt', label: this.$i18n.t('schedule.label_planablenum'), sortable: true }
      ],
      // 残計画ページング設定
      procCurrentPage: 1,
      procPerPage: 5,
      procTotalRows: 1,
      showCollapse: true,
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      isSearchRemain: false,
      // ダイアログ
      errMsg: null,
      errSbj: null
    }
  },
  created () {
    this.searchProductinfo('search')
    this.searchLine('search')

    // 更新画面から戻った場合は再検索
    var searchFlg = this.$route.query.searchFlg
    if (searchFlg !== undefined) {
      if (searchFlg[0] === 1) {
        this.moSearch = this.$store.store.state.moSearch
        this.dateSearch = this.$store.store.state.dateSearch
        this.period = this.$store.store.state.periodSearch
        this.codeListSearch = this.$store.store.state.codeSearch
        this.lineListSearch = this.$store.store.state.lineSearch
        this.search()
      }
    } else {
      // 日付の初期値に現在日時を設定
      this.dateSearch = window.formatDate(new Date(), 'yyyy-MM-dd')
    }
  },
  methods: {
    createdRegist: async function () {
      this.searchProductinfo('regist')
      this.searchLine('regist')
      // 日付取得
      var dates = await this.getDates()
      this.from = window.formatDate(dates.start, 'yyyy-MM-dd')
      this.to = window.formatDate(dates.end, 'yyyy-MM-dd')
      this.fromTime = window.formatDate(dates.start, 'HH:mm')
      this.defFromTime = this.fromTime
      this.toTime = window.formatDate(dates.end, 'HH:mm')
      this.defToTime = this.toTime
    },
    search: function () {
      // リクエスト
      var reqObj = {}
      var moStr = ''
      var start = ''
      var end = ''
      var code = ''
      var rev = ''
      var line = ''
      if (this.moSearch === null || this.moSearch === '') {
        // 稼働計画番号が入力されていない場合のみ他条件を指定
        if (this.dateSearch === '') {
          this.errSbj = this.$i18n.t('schedule.title')
          this.errMsg = this.$i18n.t('schedule.err_day_hissu')
          this.$bvModal.show('md-err')
          return
        } else if (this.period === '') {
          this.errSbj = this.$i18n.t('schedule.title')
          this.errMsg = this.$i18n.t('schedule.err_day_span_hissu')
          this.$bvModal.show('md-err')
          return
        } else {
          // 期間指定
          start = this.$moment(this.dateSearch, 'YYYY-MM-DD 00:00:00')
          // ラジオボタンの選択肢より日付を設定
          var eDate = new Date(start)
          // 日が指定された場合は日付操作は行わない
          if (this.period === '1') {
            // 週
            eDate.setDate(eDate.getDate() + 6)
          } else if (this.period === '2') {
            // 月
            eDate.setDate(eDate.getDate() + 31)
          }
          end = window.formatDate(eDate, 'yyyy-MM-dd')
          end = this.$moment(end + '23:59:59', 'YYYY-MM-DD HH:mm:ss')
          end = end.utc().format('YYYY-MM-DD HH:mm:ss')
          start = start.utc().format('YYYY-MM-DD HH:mm:ss')
        }
        // 型番
        var selected = []
        selected[0] = null
        selected[1] = null
        if (this.codeListSearch !== '') {
          selected = this.codeListSearch.split(',')
          code = selected[0]
          rev = selected[1]
        }
        // ライン
        if (this.lineListSearch !== null) {
          line = String(this.lineListSearch)
        }
      } else {
        moStr = this.moSearch
      }

      reqObj.mo = moStr
      reqObj.start = start
      reqObj.end = end
      reqObj.code = code
      reqObj.rev = rev
      reqObj.line = line

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      document.body.style.overflowY = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/schedule/selectSchedule', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          // メニューバーに被ってしまうため縦スクロールのみ表示する
          document.body.style.overflow = 'hidden'
          document.body.style.overflowY = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.setScheduleInfo(res.data.scheduleInfo)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          // メニューバーに被ってしまうため縦スクロールのみ表示する
          document.body.style.overflow = 'hidden'
          document.body.style.overflowY = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (!this.isValidRegist()) {
        return
      }

      var startDate = ''
      if (this.from !== '') {
        var from = ''
        if (this.fromTime !== '') {
          from = this.$moment(this.from + ' ' + this.fromTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          from = this.$moment(this.from + ' ' + this.defFromTime, 'YYYY-MM-DD HH:mm:00')
        }
      }
      var endDate = ''
      if (this.to !== '') {
        var to = ''
        if (this.toTime !== '') {
          to = this.$moment(this.to + ' ' + this.toTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          to = this.$moment(this.to + ' ' + this.defToTime, 'YYYY-MM-DD HH:mm:00')
        }
      }
      // 日付論理チェック
      var cmpFrom = new Date(from)
      var cmpNow = new Date()
      var cmpTo = new Date(to)
      // 開始時刻が現在時刻より前でないか
      if (cmpNow.getTime() > cmpFrom.getTime()) {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_from_before_now')
        this.$bvModal.show('md-err')
        return
      }
      // 開始と終了が逆転していないか
      if (cmpFrom.getTime() > cmpTo.getTime()) {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_from_to_reverse')
        this.$bvModal.show('md-err')
        return
      }
      startDate = from.utc().format('YYYY-MM-DD HH:mm:ss')
      endDate = to.utc().format('YYYY-MM-DD HH:mm:ss')

      // 型番
      var selected = []
      selected[0] = null
      selected[1] = null
      selected = this.codeListForm.split(',')

      //  リクエスト先の型に合わせる
      var lineStr = String(this.lineListForm)
      var sCountInt = parseInt(this.sCountForm)

      // リクエスト
      var reqObj = {}
      reqObj.start = startDate
      reqObj.end = endDate
      reqObj.code = selected[0]
      reqObj.rev = selected[1]
      reqObj.line = lineStr
      reqObj.mo = this.moForm
      reqObj.schedule_count = sCountInt

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/schedule/register', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: async function () {
      this.codeListForm = ''
      this.lineListForm = ''
      this.moForm = ''
      this.sCountForm = ''

      // 日付取得
      var dates = await this.getDates()
      this.from = window.formatDate(dates.start, 'yyyy-MM-dd')
      this.to = window.formatDate(dates.end, 'yyyy-MM-dd')
      this.fromTime = window.formatDate(dates.start, 'HH:mm')
      this.defFromTime = this.fromTime
      this.toTime = window.formatDate(dates.end, 'HH:mm')
      this.defToTime = this.toTime

      this.isSearchRemain = false
      this.$bvModal.hide('md-confirm')
    },
    searchRemain: function () {
      // 入力チェック
      if (!this.isValidRemain()) {
        return
      }
      // 型番
      var selected = []
      selected[0] = null
      selected[1] = null
      selected = this.codeListForm.split(',')
      // 稼働計画番号
      var mo = ''
      if (this.moForm !== '') {
        mo = this.moForm
      }

      var reqObj = {}
      reqObj.mo = mo
      reqObj.code = selected[0]
      reqObj.rev = selected[1]
      reqObj.line = String(this.lineListForm)

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/schedule/selectNonSchedule', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var nonScheduleList = res.data.nonScheduleInfo
            var nonSchedules = []
            // 整形
            for (var i = 0; i < nonScheduleList.length; i++) {
              var nonSchedule = {}
              nonSchedule.mo = nonScheduleList[i].mo
              nonSchedule.nonSchedulecnt = nonScheduleList[i].non_schedule_count
              nonSchedules.push(nonSchedule)
            }
            // 一旦データクリア
            this.remainingplans.splice(0)
            // データセット
            this.remainingplans.splice(0, 0, ...nonSchedules)
            // ページング設定
            this.procTotalRows = this.remainingplans.length
            // 検索結果表示
            this.isSearchRemain = true
            this.showCollapse = true
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    inputMo: function (mo, rCount) {
      // 残計画一覧から稼働計画番号を入力
      this.moForm = mo
      // rCountはLongで取得するため文字列に変換
      // (直接フォームに入力した際の型と統一するため)
      this.sCountForm = rCount.toString()
    },
    setScheduleInfo: function (scheduleInfo) {
      // 整形
      var schedules = []
      for (var i = 0; i < scheduleInfo.length; i++) {
        var schedule = {}
        // 時刻UTCに変換(start, end)
        var rStart = this.$moment.utc(scheduleInfo[i].start_datetime, 'YYYY-MM-DD HH:mm:ss')
        var rEnd = this.$moment.utc(scheduleInfo[i].end_datetime, 'YYYY-MM-DD HH:mm:ss')
        var localStart = null
        var hidStart = null
        var localEnd = null
        var hidEnd = null
        if (String(rStart) === 'Invalid date') {
          localStart = ''
        } else {
          // local時刻に変換＆フォーマット
          localStart = rStart.local().format('YYYY-MM-DD HH:mm:ss')
          hidStart = rStart.local().format('YYYYMMDDHHmmss')
        }
        if (String(rEnd) === 'Invalid date') {
          localEnd = ''
        } else {
          // local時刻に変換＆フォーマット
          localEnd = rEnd.local().format('YYYY-MM-DD HH:mm:ss')
          hidEnd = rEnd.local().format('YYYYMMDDHHmmss')
        }
        schedule.id = i + 1
        schedule.line = scheduleInfo[i].line_name
        schedule.lineId = scheduleInfo[i].line_id
        schedule.label = scheduleInfo[i].model
        schedule.hidCode = scheduleInfo[i].code
        schedule.hidRev = scheduleInfo[i].rev
        schedule.mo = '<u style="color:#0077c0;"><b-link style="color:#0077c0;">' + scheduleInfo[i].mo + '</b-link></u>'
        schedule.hidmo = scheduleInfo[i].mo
        schedule.moSeq = scheduleInfo[i].mo_seq
        schedule.schedulecnt = scheduleInfo[i].schedule_count
        schedule.start = localStart
        schedule.end = localEnd

        // 編集画面遷移用
        schedule.hidStart = hidStart
        schedule.hidEnd = hidEnd
        schedule.scheduleFlag = scheduleInfo[i].schedule_flag
        schedule.completeCount = scheduleInfo[i].complete_count
        if (scheduleInfo[i].schedule_count > 0 && scheduleInfo[i].complete_count > 0) {
          schedule.percent = scheduleInfo[i].complete_count / scheduleInfo[i].schedule_count * 100
        } else {
          // どちらかが0の場合は0を指定
          schedule.percent = 0
        }
        schedule.duration = this.calcduration(new Date(localStart), new Date(localEnd))
        schedule.type = 'task'

        schedules.push(schedule)
        // 一旦データクリア
        this.tasks.splice(0)
        // データセット
        this.tasks.splice(0, 0, ...schedules)
        // 検索結果表示
        this.isSearch = true

        // 検索結果をstoreに保持(戻るボタン対応)
        this.$store.store.state.moSearch = this.moSearch
        this.$store.store.state.dateSearch = this.dateSearch
        this.$store.store.state.periodSearch = this.period
        this.$store.store.state.periodSearch = this.period
        this.$store.store.state.codeSearch = this.codeListSearch
        this.$store.store.state.lineSearch = this.lineListSearch
      }
    },
    // duration算出
    calcduration: function (sDate, eDate) {
      var span = parseFloat((eDate.getTime() - sDate.getTime()) / 1000 / 3600)
      var duration = 1 * span * 60 * 60 * 1000
      return duration
    },
    // 型番取得
    searchProductinfo: function (flg) {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.code = ''
      body.codeLikeFlg = ''
      body.rev = ''
      body.revLikeFlg = ''
      body.petname = ''
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      // 型番取得
      this.$axios
        .post(window.END_POINT + '/master/productinfo/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var modelList = res.data.productInfo
            var codes = []

            // 整形
            for (var i = 0; i < modelList.length; i++) {
              var code = {}
              code.value = modelList[i].code + ',' + modelList[i].rev + ',' + modelList[i].petname
              code.text = modelList[i].code + ' - ' + modelList[i].rev + ' - ' + modelList[i].petname
              codes.push(code)
            }
            if (flg === 'regist') {
              // 一旦データクリア
              this.codeFormOptions.splice(1)
              // データセット
              this.codeFormOptions.splice(1, 0, ...codes)
            } else {
              // 一旦データクリア
              this.codeSearchOptions.splice(1)
              // データセット
              this.codeSearchOptions.splice(1, 0, ...codes)
            }
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // ライン取得
    searchLine: function (flg) {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      var body = {}
      body.lineId = ''
      body.lineIdLikeFlg = ''
      body.lineName = ''
      body.base = ''
      body.lineKind = ''
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true

      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineInfoList = res.data.lineInfo
            var lines = []

            // 整形
            for (var i = 0; i < lineInfoList.length; i++) {
              var line = {}
              line.value = lineInfoList[i].line_id
              line.text = lineInfoList[i].line_name
              lines.push(line)
            }
            if (flg === 'regist') {
              // 一旦データクリア
              this.lineFormOptions.splice(1)
              // データセット
              this.lineFormOptions.splice(1, 0, ...lines)
            } else {
              // 一旦データクリア
              this.lineSearchOptions.splice(1)
              // データセット
              this.lineSearchOptions.splice(1, 0, ...lines)
            }
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    isValidRegist: function () {
      // 型番
      if (this.codeListForm === null || this.codeListForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_code_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      // ライン
      if (this.lineListForm === null || this.lineListForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_line_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      // 稼働計画番号
      if (this.moForm === null || this.moForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_mo_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      // 計画数
      if (this.sCountForm === null || this.sCountForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_schedule_count_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      if (!window.checkNum(this.sCountForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_schedule_count_number')
        this.$bvModal.show('md-err')
        return false
      } else if (this.sCountForm <= 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_schedule_count_under_zero')
        this.$bvModal.show('md-err')
        return false
      }
      // 日時
      if (this.from === '' || this.to === '') {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_day_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      return true
    },
    isValidRemain: function () {
      if (this.codeListForm === null || this.codeListForm === '') {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_code_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      // ライン
      if (this.lineListForm === null || this.lineListForm === '') {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_line_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      return true
    },
    getDates: async function () {
      var startTime = ''
      var dates = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates = window.getStartTime(startTime, nowTime, false)

      return dates
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    tasksUpdate (tasks) {
      this.tasks = tasks
    },
    optionsUpdate (options) {
      this.options = options
    },
    styleUpdate (style) {
      this.dynamicStyle = style
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Schedule.vue